import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useApp } from './context/AppContext.jsx'
import Navbar from './components/Navbar.jsx'
import Footer from './components/Footer.jsx'
import Home from './pages/Home.jsx'
import TextInput from './pages/TextInput.jsx'
import VoiceSettings from './pages/VoiceSettings.jsx'
import AudioPlayer from './pages/AudioPlayer.jsx'
import MyAudioFiles from './pages/MyAudioFiles.jsx'
import Settings from './pages/Settings.jsx'

function App() {
  const { appSettings } = useApp()

  // Apply theme to document
  useEffect(() => {
    const root = document.documentElement

    if (appSettings.theme === 'dark') {
      root.classList.add('dark')
    } else if (appSettings.theme === 'light') {
      root.classList.remove('dark')
    } else {
      // Auto theme - follow system preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      if (prefersDark) {
        root.classList.add('dark')
      } else {
        root.classList.remove('dark')
      }
    }
  }, [appSettings.theme])

  // Listen for system theme changes when in auto mode
  useEffect(() => {
    if (appSettings.theme === 'auto') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
      const handleChange = (e) => {
        const root = document.documentElement
        if (e.matches) {
          root.classList.add('dark')
        } else {
          root.classList.remove('dark')
        }
      }

      mediaQuery.addEventListener('change', handleChange)
      return () => mediaQuery.removeEventListener('change', handleChange)
    }
  }, [appSettings.theme])

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
      <Navbar />
      <main className="container mx-auto px-4 py-8">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/text-input" element={<TextInput />} />
          <Route path="/voice-settings" element={<VoiceSettings />} />
          <Route path="/audio-player" element={<AudioPlayer />} />
          <Route path="/my-audio-files" element={<MyAudioFiles />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App